import React from 'react';
import DateProvider from './DateProvider';
import ThemeProvider from './ThemeProviders';

type Props = { readonly children: React.ReactNode };

function MainProvider({ children }: Props) {
  return (
    <ThemeProvider>
      <DateProvider>{children} </DateProvider>
    </ThemeProvider>
  );
}

export default MainProvider;
